import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { ChartBar } from '@phosphor-icons/react';

const STAGE_ORDER = ['inquiry', 'applied', 'interview', 'offered', 'waitlisted', 'enrolled', 'declined'];

export const FunnelPanel = () => {
  const { data } = useQuery({ queryKey: ['adm-analytics'], queryFn: () => api.get('/admissions/analytics').then((r) => r.data) });
  if (!data) return null;
  const max = Math.max(1, ...STAGE_ORDER.map((s) => data.stages?.[s] || 0));
  return (
    <div className="bg-white border border-slate-200 rounded-md p-4 mb-5" data-testid="funnel-panel">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mb-3">
        <p className="font-mono-label text-[10px] uppercase text-slate-400 flex items-center gap-1.5"><ChartBar size={14} className="text-orange-600" />Funnel analytics</p>
        <span className="text-xs text-slate-500" data-testid="funnel-total">Total <b>{data.total}</b></span>
        <span className="text-xs text-slate-500" data-testid="funnel-web-leads">Web leads <b>{data.web_leads}</b></span>
        <span className="text-xs text-green-700 font-semibold" data-testid="funnel-conversion">Conversion {data.conversion_pct}%</span>
        {data.overdue_tasks > 0 && <span className="text-xs text-rose-600 font-semibold" data-testid="funnel-overdue-tasks">{data.overdue_tasks} overdue follow-up(s)</span>}
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          {STAGE_ORDER.map((s) => (
            <div key={s} className="flex items-center gap-2 py-0.5">
              <span className="font-mono-label text-[9px] uppercase text-slate-400 w-20 shrink-0">{s}</span>
              <div className="flex-1 bg-slate-50 rounded h-3"><div className="bg-orange-500/80 h-3 rounded transition-[width]" style={{ width: `${((data.stages?.[s] || 0) / max) * 100}%` }} /></div>
              <span className="text-xs text-slate-600 w-6 text-end">{data.stages?.[s] || 0}</span>
            </div>
          ))}
        </div>
        <div className="text-xs space-y-1">
          <p className="font-mono-label text-[9px] uppercase text-slate-400">Sources</p>
          {(data.sources || []).map((s) => <p key={s.name} className="flex justify-between text-slate-600"><span>{s.name}</span><b>{s.count}</b></p>)}
          {(data.sources || []).length === 0 && <p className="text-slate-400">No applications yet.</p>}
          {(data.campaigns || []).length > 0 && <p className="font-mono-label text-[9px] uppercase text-slate-400 pt-1">UTM campaigns</p>}
          {(data.campaigns || []).map((c) => <p key={c.name} className="flex justify-between text-sky-800"><span>{c.name}</span><b>{c.count}</b></p>)}
          <p className="pt-1 text-slate-400" data-testid="funnel-weekly">Last 8 weeks: {(data.weekly || []).map((w) => w.count).join(' · ')}</p>
        </div>
      </div>
    </div>
  );
};
